module.exports = __webpack_public_path__ + "img/logo@2x.810e2535.png";